import loadScript from '../util/loader';

const hosts = {
  html5: 'html5',
  youtube: 'youtube',
};

const selectors = {
  deferredMedia: '[data-deferred-media]',
  deferredMediaButton: '[data-deferred-media-button]',
  productMediaWrapper: '[data-product-single-media-wrapper]',
  productMediaSlider: '[data-product-single-media-slider]',
  mediaContainer: '[data-video]',
  mediaId: 'data-media-id',
};

const classes = {
  mediaHidden: 'media--hidden',
};

theme.mediaInstances = {};
class Video {
  constructor(section) {
    this.section = section;
    this.container = section.container;
    this.id = section.id;
    this.players = {};
    this.init();
  }

  init() {
    const mediaContainers = this.container.querySelectorAll(selectors.mediaContainer);

    mediaContainers.forEach((mediaContainer) => {
      const deferredMediaButton = mediaContainer.querySelector(selectors.deferredMediaButton);

      if (deferredMediaButton) {
        deferredMediaButton.addEventListener('click', this.loadContent.bind(this, mediaContainer));
      }
    });
  }

  loadContent(mediaContainer) {
    if (mediaContainer.querySelector(selectors.deferredMedia).getAttribute('loaded')) {
      return;
    }

    const content = document.createElement('div');
    content.appendChild(mediaContainer.querySelector('template').content.firstElementChild.cloneNode(true));
    const mediaId = mediaContainer.dataset.mediaId;
    const element = content.querySelector('video, iframe');
    const host = this.hostFromVideoElement(element);
    const deferredMedia = mediaContainer.querySelector(selectors.deferredMedia);
    deferredMedia.appendChild(element).focus();
    deferredMedia.setAttribute('loaded', true);

    this.players[mediaId] = {
      mediaId: mediaId,
      sectionId: this.id,
      container: mediaContainer,
      element: element,
      host: host,
      ready: () => {
        this.createPlayer(mediaId);
      },
    };

    const video = this.players[mediaId];

    switch (video.host) {
      case hosts.html5:
        this.loadVideo(video, hosts.html5);
        break;
      case hosts.youtube:
        if (window.isYoutubeAPILoaded) {
          this.loadVideo(video, hosts.youtube);
        } else {
          loadScript({url: 'https://www.youtube.com/iframe_api'}).then(() => this.loadVideo(video, hosts.youtube));
        }
        break;
    }
  }

  hostFromVideoElement(video) {
    if (video.tagName === 'VIDEO') {
      return hosts.html5;
    }

    if (video.tagName === 'IFRAME') {
      if (/^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(video.src)) {
        return hosts.youtube;
      }
    }
    return null;
  }

  loadVideo(video, host) {
    if (video.host === host) {
      video.ready();
    }
  }

  createPlayer(mediaId) {
    const video = this.players[mediaId];
    const enableLooping = video.container.dataset.enableVideoLooping;

    switch (video.host) {
      case hosts.html5:
        video.element.addEventListener('play', () => {
          this.pauseOtherMedia(mediaId);
        });

        video.container.addEventListener('mediaHidden', (event) => this.onHidden(event));
        video.container.addEventListener('xrLaunch', (event) => this.onHidden(event));
        video.container.addEventListener('mediaVisible', (event) => this.onVisible(event));

        break;

      case hosts.youtube:
        if (video.host == hosts.youtube && video.player) {
          return;
        }

        YT.ready(() => {
          const videoId = video.container.dataset.videoId;

          this.players[mediaId].player = new YT.Player(video.element, {
            videoId: videoId,
            events: {
              // onReady: function(event) {},
              onStateChange: (event) => {
                if (event.data === 0) {
                  // ended
                  if (enableLooping) {
                    event.target.seekTo(0);
                  }
                }
                if (event.data === 1) {
                  // playing
                  this.pauseOtherMedia(mediaId);
                }
                if (event.data === 2) {
                  // paused
                }
              },
            },
          });

          window.isYoutubeAPILoaded = true;

          video.container.addEventListener('mediaHidden', (event) => this.onHidden(event));
          video.container.addEventListener('xrLaunch', (event) => this.onHidden(event));
          video.container.addEventListener('mediaVisible', (event) => this.onVisible(event));
        });

        break;
    }
  }

  onHidden(event) {
    if (typeof event.target.dataset.mediaId !== 'undefined') {
      const mediaId = event.target.dataset.mediaId;
      const videoPlayer = this.players[mediaId];

      if (videoPlayer.player && videoPlayer.player.pauseVideo) {
        videoPlayer.player.pauseVideo();
      } else if (videoPlayer.element && videoPlayer.element.pause) {
        videoPlayer.element.pause();
      }
    }
  }

  onVisible(event) {
    if (window.theme.touched) {
      return;
    }

    if (typeof event.target.dataset.mediaId !== 'undefined') {
      const mediaId = event.target.dataset.mediaId;
      const videoPlayer = this.players[mediaId];

      if (videoPlayer.player && videoPlayer.player.playVideo) {
        videoPlayer.player.playVideo();
      } else if (videoPlayer.element && videoPlayer.element.play) {
        videoPlayer.element.play();
      }
    }
  }

  pauseOtherMedia(mediaId) {
    const mediaIdString = `[${selectors.mediaId}="${mediaId}"]`;
    const currentMedia = document.querySelector(`${selectors.productMediaWrapper}${mediaIdString}`);
    const otherMedia = document.querySelectorAll(`${selectors.productMediaWrapper}:not(${mediaIdString})`);
    currentMedia.classList.remove(classes.mediaHidden);

    if (otherMedia.length) {
      otherMedia.forEach((element) => {
        element.dispatchEvent(new CustomEvent('mediaHidden'));
        element.classList.add(classes.mediaHidden);
      });
    }
  }
}
export default Video;
